import { Link } from "react-router-dom";
import { Crown, Lock, Check } from "lucide-react";

const PERKS = ["Daily Best Bet (Starter)", "3-5 Premium Picks daily (Pro)", "Player props & parlay suggestions (Pro)", "Live betting alerts (Pro)"];

export default function PremiumPicksBanner() {
  return (
    <div className="panel p-4 border border-smasher-gold/30 bg-gradient-to-b from-smasher-gold/10 to-transparent" data-testid="premium-picks-banner">
      <div className="flex items-center gap-2 font-heading font-black tracking-wide text-smasher-gold text-sm"><Crown className="w-4 h-4" /> THE BEST PICKS ARE FOR MEMBERS</div>
      <p className="text-[11px] text-slate-300 mt-2 leading-relaxed">
        These free picks are a sample — the market's strongest favorites, capped at 3 per sport. Our premium plays go deeper: value spots, underdogs and props the public board never shows.
      </p>
      <ul className="mt-2 space-y-1">
        {PERKS.map((p) => (
          <li key={p} className="flex items-start gap-1.5 text-[11px] text-slate-200"><Check className="w-3 h-3 mt-0.5 text-emerald-400 shrink-0" /> {p}</li>
        ))}
      </ul>
      <Link to="/membership" className="mt-3 flex items-center justify-center gap-1.5 w-full py-2.5 rounded-lg btn-gold font-heading font-black text-xs tracking-wide hover:brightness-110 transition" data-testid="premium-picks-cta">
        <Lock className="w-3.5 h-3.5" /> UNLOCK PREMIUM PICKS · FROM $29/MO
      </Link>
      <p className="text-[9px] text-slate-500 text-center mt-1.5">Starter $29/mo · Pro $69/mo · cancel anytime</p>
    </div>
  );
}
